<script lang="ts">
    import { _, locale } from 'svelte-i18n';
    import { Participant, Autocomplete, getParticipant, getAutocomplete } from "../helpers/api";
    import { getProviderIcon } from "../helpers/provider";
    import ResultTable from "./ResultTable.svelte";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let search = {id: '', search: '', filter: 'all', auto: true};
    export let arrow = '';
    let recoms: Autocomplete[] = [];
    let result: Participant = null;
    let resultId: string = '';
    let keyTimeout = null;

    $: {
        loadResults(search, search.auto);
        search.auto = true;

        handleKeyArrow(arrow);

        if (search.id == '') {
            recoms = [];
        }

        if (resultId != '') {
            history.pushState({}, null, "/search/" + resultId);
        }
    }

    locale.subscribe(function () {
        changeResult(search.id);
    });

    function loadResults(searchInput, auto = true) {
        if (searchInput !== undefined) {
            if (search.id.length > 0) {
                let searchString = search.search;
                getParticipant(search.id, $_('code')).then((res) => {
                    if (auto) {
                        if (searchString == '') {
                            searchString = res.address[0].name;
                            (document.getElementById('input') as HTMLInputElement).value = searchString;
                            if (window.outerWidth > 768) {
                                document.getElementById('input').focus();
                            }
                        }
                        getAutocomplete(searchString, search.filter, $_('code')).then((res) => {
                            recoms = res;
                            resultId = searchInput.id;
                            setTimeout(() => {
                                handleTableHeight();
                            }, 10);
                        });
                    }
                    result = res;
                });
            }
        } else {
            recoms = [];
            result = null;
        }
    }

    function handleKeyArrow(direction: string) {
        clearTimeout(keyTimeout);
        setTimeout(() => {
            if (direction != '') {
                let selectedElm;
                let currentElm = document.getElementById(search.id);
                if (direction == 'up') {
                    selectedElm = currentElm.previousSibling;
                    if (selectedElm == null) {
                        selectedElm = currentElm.parentElement.lastChild;
                    }
                } else if (direction == 'down') {
                    selectedElm = currentElm.nextSibling;
                    if (selectedElm == null) {
                        selectedElm = currentElm.parentElement.firstChild;
                    }
                }

                if (selectedElm != null) {
                    if (selectedElm.previousSibling) {
                        selectedElm.previousSibling.scrollIntoView();
                    } else {
                        selectedElm.scrollIntoView();
                    }
                    changeResult(selectedElm.id);
                }

                arrow = '';
            }
        }, 100);
    }

    function handleMouseSelect() {
        changeResult(this.id, false);
        document.getElementById('input').focus();
    }

    function changeResult(id: string, auto: boolean = true) {
        resultId = id;
        search = {
            id: id,
            search: search.search,
            filter: search.filter,
            auto: auto
        };
    }

    function handleTableHeight() {
        let resultList = document.getElementById('result-list');
        if (resultList != null) {
            let resultTable = document.getElementById('result-table');
            if (resultTable != null) {
                let height = resultTable.clientHeight;
                if (height < 400) {
                    height = 400;
                }
                resultList.style.height = height + 'px';
            }
        }
    }

    function mobBack() {
        dispatch('back', result.address[0].name);
    }
</script>

<svelte:window on:resize={handleTableHeight} />

{#if recoms.length !== 0}
    <div class="flex py-4 bg-white border-t border-solid border-color">
        <div id="result-list" class="hidden md:block w-4/12 px-2 overflow-x-auto">
            {#each recoms as recom}
                <div id={recom.id} on:click={handleMouseSelect}
                     class="flex py-2 cursor-pointer {resultId === recom.id ? 'bg-secondary' : 'hover:bg-primary'}">
                    <div class="w-10/12">
                        <div>
                            <div class="px-1">{recom.name}</div>
                            <div class="px-1 text-sm">{recom.name2}</div>
                        </div>
                    </div>
                    <div class="flex items-center w-2/12 px-1">
                        <div>
                            <img src={getProviderIcon(recom.providerID.toString())} width="28px" height="28px"
                                 alt="provider icon" />
                        </div>
                    </div>
                </div>
            {/each}
        </div>
        <div class="w-12/12 md:w-8/12 px-4 md:px-2 border-l border-solid border-color">
            {#if result == null}
                <div class="flex justify-center items-center space-x-2 h-full">
                        <div style="border-top-color:transparent"
                             class="w-12 h-12 border-4 border-darkblue border-solid rounded-full animate-spin"></div>
                </div>
            {:else}
                <div id="result-table">
                    <ResultTable result={result} on:back={mobBack} />
                </div>
            {/if}
        </div>
    </div>
{/if}

<style windi:preflights>
</style>
